export const version = "contracts/5.6.2";
//# sourceMappingURL=_version.js.map